import { useFetchProfile } from '@/hooks/useFetchProfile'
import { cn } from '@/lib/utils'

export default function SlashCommandPreview({
  command,
  author,
  className
}: {
  command: string
  author: string
  className?: string
}) {
  const { profile } = useFetchProfile(author)
  const authorName = (profile?.shortName ?? author).replace(/^@+/, '')

  return <span className={cn('text-primary', className)}>{`/${command} @${authorName}`}</span>
}
